import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp, FaTshirt, FaShippingFast, FaAward, FaHeart } from 'react-icons/fa';
import Logo from '../assets/Logo.svg';

function Footer() {
    const currentYear = new Date().getFullYear();

    const quickLinks = [
        { name: 'Home', path: '/' },
        { name: 'About Us', path: '/about' },
        { name: 'Products', path: '/products' },
        { name: 'Contact', path: '/contact' }
    ];

    const categories = [
        { name: 'Men\'s Wear', path: '/products?category=men' },
        { name: 'Women\'s Wear', path: '/products?category=women' },
        { name: 'Kids Wear', path: '/products?category=kids' },
        { name: 'All Products', path: '/products' }
    ];

    const socialLinks = [
        { icon: <FaFacebook />, url: 'https://facebook.com', label: 'Facebook' },
        { icon: <FaInstagram />, url: 'https://instagram.com', label: 'Instagram' },
        { icon: <FaLinkedin />, url: 'https://linkedin.com', label: 'LinkedIn' },
        { icon: <FaWhatsapp />, url: 'https://wa.me/919585284627', label: 'WhatsApp' }
    ];

    return (
        <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
            {/* Main Footer */}
            <div className="max-w-7xl mx-auto px-4 py-16">
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
                    {/* Company Info */}
                    <div className="space-y-6">
                        <Link to="/" className="flex items-center gap-3 group">
                            <img src={Logo} alt="SS Tex Logo" className="h-12 w-12 transform group-hover:scale-110 transition duration-300" />
                            <div>
                                <div className="text-2xl font-bold text-white group-hover:text-yellow-300 transition">SS Tex</div>
                                <div className="text-xs text-gray-400">Premium Garments</div>
                            </div>
                        </Link>
                        <p className="text-gray-400 leading-relaxed">
                            Tiruppur's trusted garment manufacturer serving wholesale & retail markets for 7+ years. We deliver premium quality apparel for men, women, and kids at factory-direct prices.
                        </p>
                        <div className="flex gap-3">
                            {socialLinks.map((social) => (
                                <a
                                    key={social.label}
                                    href={social.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-10 h-10 bg-white/10 hover:bg-primary-600 rounded-full flex items-center justify-center transition transform hover:scale-110"
                                    aria-label={social.label}
                                >
                                    {social.icon}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-lg font-bold mb-6 text-yellow-300">Quick Links</h3>
                        <ul className="space-y-3">
                            {quickLinks.map((link) => (
                                <li key={link.path}>
                                    <Link to={link.path} className="text-gray-400 hover:text-white hover:pl-2 transition-all flex items-center gap-2 group">
                                        <span className="text-primary-400 opacity-0 group-hover:opacity-100 transition">›</span>
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Product Categories */}
                    <div>
                        <h3 className="text-lg font-bold mb-6 text-yellow-300">Categories</h3>
                        <ul className="space-y-3">
                            {categories.map((cat) => (
                                <li key={cat.path}>
                                    <Link to={cat.path} className="text-gray-400 hover:text-white hover:pl-2 transition-all flex items-center gap-2 group">
                                        <span className="text-primary-400 opacity-0 group-hover:opacity-100 transition">›</span>
                                        {cat.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-lg font-bold mb-6 text-yellow-300">Contact Us</h3>
                        <ul className="space-y-4">
                            <li>
                                <a href="tel:+919585284627" className="flex items-start gap-3 text-gray-400 hover:text-white transition group">
                                    <FaPhone className="text-primary-400 mt-1 group-hover:scale-110 transition" />
                                    <div>
                                        <div className="text-sm text-gray-500">Call Us</div>
                                        <div className="font-medium">+91 95852 84627</div>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="mailto:sstexonline@gmail.com" className="flex items-start gap-3 text-gray-400 hover:text-white transition group">
                                    <FaEnvelope className="text-primary-400 mt-1 group-hover:scale-110 transition" />
                                    <div>
                                        <div className="text-sm text-gray-500">Email Us</div>
                                        <div className="font-medium">sstexonline@gmail.com</div>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <div className="flex items-start gap-3 text-gray-400">
                                    <FaMapMarkerAlt className="text-primary-400 mt-1" />
                                    <div>
                                        <div className="text-sm text-gray-500">Location</div>
                                        <div className="font-medium">Tiruppur, Tamil Nadu</div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Features Bar */}
                <div className="grid md:grid-cols-3 gap-6 mt-16 pt-12 border-t border-gray-700">
                    <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-primary-600/20 rounded-full flex items-center justify-center">
                            <FaTshirt className="text-2xl text-primary-400" />
                        </div>
                        <div>
                            <div className="font-bold">Premium Quality</div>
                            <div className="text-sm text-gray-400">100% Quality Assured</div>
                        </div>
                    </div>
                    <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-primary-600/20 rounded-full flex items-center justify-center">
                            <FaShippingFast className="text-2xl text-primary-400" />
                        </div>
                        <div>
                            <div className="font-bold">All-India Delivery</div>
                            <div className="text-sm text-gray-400">Fast & Reliable Shipping</div>
                        </div>
                    </div>
                    <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-primary-600/20 rounded-full flex items-center justify-center">
                            <FaAward className="text-2xl text-primary-400" />
                        </div>
                        <div>
                            <div className="font-bold">7+ Years Experience</div>
                            <div className="text-sm text-gray-400">Trusted by 2000+ Businesses</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-gray-700 bg-gray-900/50">
                <div className="max-w-7xl mx-auto px-4 py-6">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <p className="text-gray-400 text-sm text-center md:text-left">
                            © {currentYear} SS Tex. All rights reserved. | Developed by <a href='https://www.catchify.info/'>Catchify Technologies</a>
                        </p>
                        <div className="flex gap-6 text-sm">
                            <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition">Privacy Policy</Link>
                            <Link to="/terms-condition" className="text-gray-400 hover:text-white transition">Terms of Service</Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;